import { getIntegrationBusinesses } from "selectors/root";
import { selectIntegrationBusinessIdsByTypeLookup } from "selectors/indexes";
import { createLookupCombiner, createLookupSelectors } from "selectors/lib";
import { EMPTY_ARRAY } from "lib";

export const getIntegrationBusinessById =
  (integrationBusinessId: string) => (state: State) =>
    getIntegrationBusinesses(state)[integrationBusinessId] || null;

export const [
  selectIntegrationBusinessesByTypeLookup,
  getIntegrationBusinessesByType,
] = createLookupSelectors(
  [selectIntegrationBusinessIdsByTypeLookup, getIntegrationBusinesses],
  createLookupCombiner(
    (
      integrationBusinessIds: number[],
      integrationBusinessByIdLookup: Record<number, IntegrationBusiness>,
    ) =>
      integrationBusinessIds.map(
        (integrationBusinessId: number) =>
          integrationBusinessByIdLookup[integrationBusinessId],
      ),
  ),
) as [
  (state: State) => Record<number, IntegrationBusiness[]>,
  (type: string) => (state: State) => IntegrationBusiness[] | null,
];

export const [
  selectIntegrationBusinessesByBusinessIdByTypeLookup,
  getIntegrationBusinessesByBusinessIdLookupByType,
] = createLookupSelectors(
  [selectIntegrationBusinessesByTypeLookup],
  createLookupCombiner((integrationBusinessesOfType: IntegrationBusiness[]) =>
    Object.values(integrationBusinessesOfType).reduce(
      (acc, integrationBusiness) => {
        if (!integrationBusiness.businessId) {
          return acc;
        }
        if (!acc[integrationBusiness.businessId]) {
          acc[integrationBusiness.businessId] = [];
        }
        acc[integrationBusiness.businessId].push(integrationBusiness);
        return acc;
      },
      {},
    ),
  ),
) as [
  (state: State) => Record<string, Record<string, IntegrationBusiness[]>>,
  (
    type: string,
  ) => (state: State) => Record<string, IntegrationBusiness[]> | null,
];

export const getIntegrationBusinessesByTypeByBusinessId =
  (type: string, business_id: string) => (state: State) =>
    getIntegrationBusinessesByBusinessIdLookupByType(type)(state)?.[
      business_id
    ] || EMPTY_ARRAY;
